import { render, staticRenderFns } from "./activity-form-v2.vue?vue&type=template&id=365562ae&"
import script from "./activity-form-v2.vue?vue&type=script&lang=ts&"
export * from "./activity-form-v2.vue?vue&type=script&lang=ts&"
import style0 from "./activity-form-v2.vue?vue&type=style&index=0&lang=scss&_scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports